module.exports = __webpack_public_path__ + "static/1-58b1c0655f00129dd5cf4140b42c8c6a.png";